import React from 'react';

import classNames from 'classnames';

import styles from './Text.module.scss';
import './Text.style.scss';

interface BaseTextProps {
  className?: string;
  tag?: keyof React.JSX.IntrinsicElements;
  children: React.ReactNode;
}

interface TextProps extends BaseTextProps {
  weight?: 'bold' | 'light' | 'medium' | 'regular';
}

const BaseText = (props: BaseTextProps) => {
  const className = classNames({
    [styles.text]: true,
    [props.className as string]: !!props.className,
  });
  const Tag = props.tag || 'p';

  return (
    <Tag {...props} className={className}>
      {props.children}
    </Tag>
  );
};

const H1 = (props: TextProps) => {
  const className = classNames({
    [styles.h1]: true,
    [props.weight as string]: !!props.weight,
    [props.className as string]: !!props.className,
  });
  return (
    <BaseText {...props} className={className} tag={'h1'}>
      {props.children}
    </BaseText>
  );
};

const H2 = (props: TextProps) => {
  const className = classNames({
    [styles.h2]: true,
    [props.weight as string]: !!props.weight,
    [props.className as string]: !!props.className,
  });
  return (
    <BaseText {...props} className={className} tag={'h2'}>
      {props.children}
    </BaseText>
  );
};

const H3 = (props: TextProps) => {
  const className = classNames({
    [styles.h3]: true,
    [styles.text]: true,
    [props.weight as string]: !!props.weight,
    [props.className as string]: !!props.className,
  });
  return (
    <BaseText {...props} className={className} tag={'h3'}>
      {props.children}
    </BaseText>
  );
};

const H4 = (props: TextProps) => {
  const className = classNames({
    [styles.h4]: true,
    [props.weight as string]: !!props.weight,
    [props.className as string]: !!props.className,
  });
  return (
    <BaseText {...props} className={className} tag={'h4'}>
      {props.children}
    </BaseText>
  );
};

const H5 = (props: TextProps) => {
  const className = classNames({
    [styles.h5]: true,
    [props.weight as string]: !!props.weight,
    [props.className as string]: !!props.className,
  });
  return (
    <BaseText {...props} className={className} tag={'h5'}>
      {props.children}
    </BaseText>
  );
};

const Bigger = (props: TextProps) => {
  const className = classNames({
    [styles.bigger]: true,
    [props.weight as string]: !!props.weight,
    [props.className as string]: !!props.className,
  });
  return (
    <BaseText {...props} className={className}>
      {props.children}
    </BaseText>
  );
};

const Big = (props: TextProps) => {
  const className = classNames({
    [styles.big]: true,
    [props.weight as string]: !!props.weight,
    [props.className as string]: !!props.className,
  });
  return (
    <BaseText {...props} className={className}>
      {props.children}
    </BaseText>
  );
};

const Normal = (props: TextProps) => {
  const className = classNames({
    [styles.normal]: true,
    [props.weight as string]: !!props.weight,
    [props.className as string]: !!props.className,
  });
  return (
    <BaseText {...props} className={className}>
      {props.children}
    </BaseText>
  );
};

const Regular = (props: TextProps) => {
  const className = classNames({
    [styles.regular]: true,
    [props.weight as string]: !!props.weight,
    [props.className as string]: !!props.className,
  });
  return (
    <BaseText {...props} className={className}>
      {props.children}
    </BaseText>
  );
};

const Small = (props: TextProps) => {
  const className = classNames({
    [styles.small]: true,
    [props.weight as string]: !!props.weight,
    [props.className as string]: !!props.className,
  });
  return (
    <BaseText {...props} className={className}>
      {props.children}
    </BaseText>
  );
};

export const Text = Object.assign(BaseText, {
  H1,
  H2,
  H3,
  H4,
  H5,
  Bigger,
  Big,
  Normal,
  Regular,
  Small,
});
